import { render, staticRenderFns } from "./PropertyDetails.vue?vue&type=template&id=5530f14c&scoped=true&"
import script from "./PropertyDetails.vue?vue&type=script&lang=ts&"
export * from "./PropertyDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyDetails.vue?vue&type=style&index=0&id=5530f14c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5530f14c",
  null
  
)

export default component.exports